import { LOCALES, KEYS } from '../constants';

const jaJATranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_JAPANESE_JA]: {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"パートナーのロール",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"インテグレータ",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"プロバイダー",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"パートナーレベル",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"パートナー スペシャライゼーション",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:"Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"パートナー名",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"ロケーション",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"国",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"パートナー名のキーワード",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"パートナー名のキーワード",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"ソート",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"スペシャライゼーション",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"パートナー スペシャライゼーション",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"プロバイダーレベルおよび Cisco Powered サービス",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"ゴールドプロバイダー",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"プレミアプロバイダー",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"セレクトプロバイダー",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"アドバイスを得る",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"見積もりの依頼",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"オープン",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Expand（アップセル）",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"折りたたむ",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"国/地域を選択",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"ロールを選択",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"スペシャライゼーションを選択",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Cisco Powered サービスを選択",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"専門分野を選択",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"レベルを選択",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"パートナーの国/地域",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"インテグレータレベル",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"プロバイダーレベル",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"インテグレータ スペシャライゼーション",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered サービス",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"パートナー名",
    [KEYS.L18N_KEY_LABEL_BACK ]:"戻る",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"すべての結果",
    [KEYS.L18N_KEY_LABEL_ALL ]:"すべて",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"保存済み",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"パートナー",
    [KEYS.L18N_KEY_LABEL_ADD ]:"追加",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"削除",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"追加して比較 ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"少なくとももう 1 つ選択してください",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"選択した項目を比較 ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"比較演算子から削除",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"比較",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"パートナーレベル",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"処理が進行中",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"結果",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"結果",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"該当なし",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"結果",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"結果",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"結果なし",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"前へ",
    [KEYS.L18N_KEY_LABEL_PREV ]:"前へ",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"[次へ(Next)]",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"保存",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"専門分野",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"概要",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"はシスコです",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"インテグレータは、お客様向けにエンドツーエンドのソリューションを構築します。主に再販形式で取引を行いますが、独自の専門知識を活用してお客様のビジネス上の問題も解決します。",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"プロバイダーは、マネージドソリューションとクラウドソリューションを提供する専門家です。顧客はソリューションをより柔軟に利用できる方法を求めていて、市場ではプロバイダーの重要性がますます高まっています。",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"過去の検索",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"過去の検索",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"ロール",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"技術",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"業界",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"インテグレータ",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"プロバイダー",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"その他",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"その他",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"他のパートナーは保存されていません",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"保存されたインテグレータはありません",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"保存されたプロバイダーはありません",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"ニーズでフィルタ処理",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"条件を組み合わせて検索",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"場所による検索",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"世界中でサービスを提供しているパートナーが 1 社あります",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"マッピングされているドライブが",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"世界中でサービスを提供しているパートナーがあります",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"サービスを提供しているパートナーはありません",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"次の分野でサービスを提供しているパートナーが 1 社あります",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"次の分野でサービスを提供しているパートナー",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"次の分野でサービスを提供しているパートナーはありません",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"場所を変更",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"ニーズでフィルタ処理",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"検索",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"名前、レベル、専門分野による",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"選択済み",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"一致するものが見つかりませんでした",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"ランク（昇順）",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"ランク（降順）",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"名前（昇順）",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"名前（降順）",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"ログインが必要です",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"このアクションを実行するにはログインする必要があります",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"検索の復元に失敗しました",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"ログイン",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"パートナーは正常に保存されました。",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"パートナーを保存できませんでした",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"パートナーが正常に削除されました。",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"パートナーを削除できませんでした",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"キーワードを入力して名前、レベル、または専門分野で検索",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"デベロッパーは、シスコのテクノロジーを基盤として、カスタマイズしたソフトウェアとハードウェアソリューションを構築するエキスパート。これらのソリューションがシステム間をつなぐ独自のソリューションとなり、ビジネスの成果をもたします。",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"アドバイザーは、業界に関する深い知識を持ち、ビジネス上の複雑な課題の解決を支援するエキスパート。",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"多様なパートナー",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"アルファベット順",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"専門分野に最も精通",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"デベロッパー",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"アドバイザー",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"フィルタ",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"フィルタ",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"パートナーの専門分野",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"表示を消す",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"スペシャライゼーション",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"専門分野",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"説明はありません。",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"弊社について",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"比較条件をクリア",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"パートナーの比較",
    [KEYS.L18N_KEY_LABEL_ROLE]:"ロール",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"重点を置くテクノロジー分野",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"説明",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"言語の選択",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"ログアウト",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"インクルーシブパートナー",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]:"シスコについて",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]:"お問い合わせ",
    [KEYS.L18N_KEY_LABEL_CAREERS]:"キャリア",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]:"パートナーに会う",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]:"フィードバック",
    [KEYS.L18N_KEY_LABEL_HELP]:"ヘルプ",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]:"利用規約",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]:"プライバシーステートメント",
    [KEYS.L18N_KEY_LABEL_COOKIES]:"Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]:"商標",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]:"サプライチェーンの透明性",
    [KEYS.L18N_KEY_LABEL_SITEMAP]:"サイトマップ",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "シスコについて",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "お問い合わせ",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "キャリア",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "パートナーに会う",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "フィードバック",
    [KEYS.L18N_KEY_LABEL_HELP]: "ヘルプ",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "利用規約",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "プライバシーステートメント",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookie",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "商標",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "サプライチェーンの透明性",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "サイトマップ",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "購入方法",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "パートナー",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "製品とサービス",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "ソリューション",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "サポート",
    [KEYS.L18N_KEY_LABEL_LEARN]: "学ぶ",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "シスコを探索する",
    [KEYS.L18N_KEY_LABEL_MENU]: "メニュー",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "閉じる",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "もっと見る",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "表示が少ない",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "アカウントをお持ちではありませんか？",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "サインアップ",
  }
});

export default jaJATranslations;
